module.exports = __webpack_public_path__ + "assets/16d8b6d1d3dcf547005f395c4c07997d.mp3";